// extracted by mini-css-extract-plugin
export default {"modal":"LevelTestModalMarketing_modal__fkjaa","btns":"LevelTestModalMarketing_btns__Oi5Jo"};